export enum UserRoles {
  SystemAdministrator = 3,
  OnBehalfOf = 5,
  StaffAdministrator = 13,
}
